import { useEffect, useMemo } from "react";
import { IColumnProps } from "devextreme-react/data-grid";
import { IItemProps } from "devextreme-react/form";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";
import { journalEntryTypeOptionItems } from "../../model/constants/enums";
import { createFormulaEditCellComponent } from "../../components/formulaEditor";
import { FormulaContextKeys } from "../../model/formula";
import { BaseMappings } from "./BaseMappings";
import { referenceMappingColumns, dummyReferenceMappingRow } from "./model/metaData";

const FORMULA_FIELDS = ["numberReferenceFormula", "stringReferenceFormula"];

export const ReferenceMappings = (pageProps: PageProps) => {
  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  const logger = pageProps.loggerProvider.getLogger("ReferenceMappings");

  const httpClient = pageProps.appUtil.httpClients["eAccountingService"];

  // Render the formula editor through the column's `editCellComponent` so the DataGrid's editing
  // controller supplies the current value and receives changes. A form-item template would bypass
  // that binding and open with an empty editor for existing rows.
  const formulaEditCellComponent = useMemo(
    () =>
      createFormulaEditCellComponent({
        httpClient,
        contextKey: FormulaContextKeys.TessituraContext,
        rootObjects: ["TransactionInfo"],
      }),
    [httpClient],
  );

  const columnConfigs = useMemo(() => {
    const configs = new Map<string, IColumnProps>(referenceMappingColumns);
    FORMULA_FIELDS.forEach((field) => {
      const existing = configs.get(field) ?? { dataField: field };
      configs.set(field, { ...existing, editCellComponent: formulaEditCellComponent });
    });
    return configs;
  }, [formulaEditCellComponent]);

  const editorItemOptions = useMemo(() => new Map<string, IItemProps>([
    [
      "journalEntryTypeOption",
      {
        editorType: "dxSelectBox",
        editorOptions: {
          dataSource: journalEntryTypeOptionItems,
          displayExpr: "text",
          valueExpr: "value",
        },
      },
    ],
  ]), []);

  return (
    <BaseMappings
      logger={logger}
      {...pageProps}
      baseUrl="reference-mappings"
      formTitle="Reference Mapping"
      dummyRow={dummyReferenceMappingRow}
      columnConfigs={columnConfigs}
      additionalEditorItemOptions={editorItemOptions}
    />
  );
};
